// directive
//   <authorize-account-form />
//
// Presented when the account has limited capabilities and needs to be authorized
// in order to proceed. Fires off an API call to begin authorization and presents
// a confirmation.

angular.module('app.directives').component('authorizeAccountForm', {
  restrict: 'E',
  template: `
    <form>
      <div class="form-group">
        <label for="eventName">Organization Name <i class="fa fa-asterisk text-danger" style="font-size:10px;vertical-align:top"></i></label>
        <input type="text" class="form-control" id="eventName" ng-model="vm.service.broadcast.name" required>
      </div>
      <div class="form-group">
        <label for="eventName">Organization Phone Number <i class="fa fa-asterisk text-danger" style="font-size:10px;vertical-align:top"></i></label>
        <input type="text" class="form-control" id="eventName" ng-model="vm.service.broadcast.name" required>
      </div>
      <div class="form-group">
        <label for="eventName">Organization Web Site <span class="text-muted" style="font-weight:normal">(optional)</span></label>
        <input type="text" class="form-control" id="eventName" ng-model="vm.service.broadcast.name" required>
      </div>
      <div class="form-group" style="margin-top:15px">
        <span ng-click="vm.scheduleAgain = !vm.scheduleAgain" style="cursor:pointer;opacity:0.8;line-height:30px;">
          <i class="fa fa-2x" ng-class="vm.scheduleAgain ? 'fa-check-square-o' : 'fa-square-o'"
            style="width:30px;line-height:30px;vertical-align:bottom;"></i>
          I am authorized to stream events for this organization.
        </span>
      </div>
      <button type="button" class="btn btn-success btn-block" ng-click="vm.submit()" ng-disabled="vm.submitting">
        <i ng-show="vm.submitting" class="fa fa-spin fa-spinner"></i>
        Authorize Account
      </button>
    </form>
  `,
  controllerAs: 'vm',
  controller: function AuthorizeAccountFormController(Account, $http, $timeout) {
    'ngInject';
  },
});



// WEBPACK FOOTER //
// ./app/directives/authorize-account-form.js